import React from 'react';
import Link from 'next/link';
import { PrismicJobListing } from '../../types/prismic';
import FixedRatioImage from '../base/FixedRatioImage';

import styles from '../../styles/pages/jobs-listing.module.sass';

interface Props {
  job: PrismicJobListing;
}

const JobsListingItem = ({ job }: Props) => {
  const {
    data: { image, position, company, city, state, country },
  } = job;

  const locationSections = [];
  if (city && city.length) locationSections.push(city);
  if (state && state.length) locationSections.push(state);
  if (country && country.length) locationSections.push(country);

  // const location =
  //   state && state.length ? `${city}, ${state}, ${country}` : `${city}, ${country}`;

  const location = locationSections.toString().replace(/,/g, ', ');
  const thumbUrl = image.thumb && image.thumb.url ? image.thumb.url : image.url;

  return (
    <Link href={`/jobs-listing/${job.uid}`}>
      <a>
        <FixedRatioImage image={thumbUrl} ratio="1x1" interactive />
        <div className="column center text-center">
          <p className={styles.title}>{position}</p>
          <p className={styles.company}>{company}</p>
          <p className={styles.location}>{location}</p>
        </div>
      </a>
    </Link>
  );
};

export default JobsListingItem;
